var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.95 21.95c-1.25-.41-2.05-1.79-1.77-3.07l.49-3.15c.01-.07.01-.17-.06-.25a.28.28 0 0 0-.2-.08h-4c-.98 0-1.83-.41-2.33-1.12-.49-.69-.59-1.6-.27-2.48L4.2 4.52C4.57 3.07 6.12 1.9 7.72 1.9h3.8c.56 0 1.78.17 2.43.82l3.03 2.34-.92 1.19-3.1-2.4c-.25-.25-.88-.45-1.44-.45h-3.8c-.9 0-1.87.72-2.07 1.53l-2.42 7.35c-.16.44-.13.84.08 1.13.22.31.62.49 1.11.49h4c.52 0 1 .22 1.33.6.34.39.49.91.41 1.45l-.5 3.21c-.12.56.26 1.19.8 1.37.48.18 1.12-.08 1.34-.4l4.1-6.1 1.24.84-4.1 6.1c-.47.7-1.36 1.13-2.24 1.13-.29 0-.58-.05-.85-.15z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.62 18.1c-1.85 0-2.75-.87-2.75-2.65v-9.8c0-1.78.9-2.65 2.75-2.65h1c1.85 0 2.75.87 2.75 2.65v9.8c0 1.78-.9 2.65-2.75 2.65h-1zM17.37 5.65v9.8c0 .89.16 1.15 1.25 1.15h1c1.09 0 1.25-.26 1.25-1.15v-9.8c0-.89-.16-1.15-1.25-1.15h-1c-1.09 0-1.25.26-1.25 1.15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineDislike);
export default __webpack_public_path__ + "static/media/vuesax-outline-dislike.9cb600410118740b2db22988b939a3d6.svg";
export { ForwardRef as ReactComponent };